<template>
  <div class="py-6 px-5 sm:p-8 bg-light w-screen md:max-w-md h-screen md:h-auto flex flex-col justify-center">
    <h2 class="flex font-semibold text-lg md:text-xl text-bolder mb-2">
      {{ $t('text-report-ad') }}
    </h2>
    <hr class="mb-2 md:mb-4" >
    <div class="text-sm truncate w-full mb-5">
      {{ $t('text-reporting-ad') }}: <span class="font-bold">{{ store?.product?.name || '' }}</span>
    </div>
    <form @submit.prevent="">
      <div class="flex flex-col w-full">
        <Input
          v-model="name"
          :label="$t('text-name')"
          name="name"
          type="text"
          variant="outline"
          class-name="mb-5"
          :error="errors?.name?.message ? $t(errors.name.message) : ''"
        />
        <Input
          v-model="email"
          :label="$t('text-email')"
          name="email"
          type="text"
          variant="outline"
          class-name="mb-5"
          :error="errors?.email?.message ? $t(errors.email.message) : ''"
        />
        <TextArea
          v-model="description"
          :label="$t('text-reporting-details')"
          name="description"
          type="text"
          variant="outline"
          class-name="w-full mb-5"
          :error="errors?.description?.message ? $t(errors.description.message) : ''"
        />
      </div>
    </form>
    <div class="flex flex-col sm:flex-row items-center justify-between w-full">
      <Button
          class="sm:mr-3 mt-5 sm:mt-0 w-full sm:w-fit"
          variant="outline"
          :on-click="handleClose"
      >
        {{ $t('text-cancel') }}
      </Button>
      <Button
          class="mt-5 sm:mt-0 w-full sm:w-fit"
          :disabled="loading"
          :loading="loading"
          :on-click="handleSubmit"
      >
        {{ $t('text-submit-report') }}
      </Button>
    </div>
  </div>
</template>

<script setup>
import _ from 'lodash-es';
import { ROUTES } from "@utils/routes";
import { useReCaptcha } from 'vue-recaptcha-v3';
import { useSelectedStore } from '@stores/selected';
import { useCustomerStore } from '@stores/customer';
import Input from "@components/ui/input";
import TextArea from "@components/ui/text-area";
import Button from "@components/ui/button";

const store = useSelectedStore();
const customer = useCustomerStore();
const { t } = useI18n();
const { $eventBus, $toast } = useNuxtApp();
const config = useRuntimeConfig();

const errors = ref({});
const loading = ref(false);
const name = ref(customer?.fullName || '');
const email = ref(customer?.email || '');
const description = ref('');

const recaptchaInstance = useReCaptcha();
const recaptcha = async () => {
    await recaptchaInstance?.recaptchaLoaded();
    return await recaptchaInstance?.executeRecaptcha('reportad');
};

const handleClose = () => {
  $eventBus.emit('modal:close');
  if (store.action === 'RETURN_TO_PRODUCT_MODAL') {
    $eventBus.emit('modal:open', 'PRODUCT_DETAILS');
    store.setAction(null);
  }
};

const handleSubmit = async () => {
  loading.value = true;
  const result = await sendContactForm({
    name: name.value,
    email: email.value,
    subject: `${t('text-reporting-ad')}: ${store?.product?.name || ''}`,
    content: _.trim(description.value + '\n\n' + config.public.appBaseUrl + translatePath(ROUTES.CODE.PRODUCT, slugify(store?.product?.id, store?.product?.name))),
    recaptchaToken: await recaptcha()
  });
  if (result !== null) {
    handleClose();
    $eventBus.emit('toast:success', 'success.report-ad-form.submit');
  } else {
    $toast.error(t('error.report-ad-form.submit'));
  }
  loading.value = false;
}

</script>
